import React, {useState} from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import moment from 'moment'
import Popover from '@mui/material/Popover'
import {Create, Delete} from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import LinkedField from 'components/LinkedField'

const Value = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 55px;
    line-height: 55px;
`

const Label = styled.div`
    font-weight: 600;
    margin: 10px 10px 0 10px;
`

const Field = styled.div`
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: rgba(160, 183, 190, 0.24);
    margin: 18px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`

const PopoverContent = styled.div`
    min-width: ${props => props.minWidth}px;
    margin: 18px;
`

const Text = styled.span`
    margin-right: auto;
    font-size: 13px;
    color: #a0b7be;
    letter-spacing: 0.3px;
`

const Title = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    svg {
        font-size: 20px;
    }
`

const EventPopover = ({config, intl, handleDelete, handleEdit, permissions,
    eventData, onClose, anchorEl, scheduler, updateEvent}) => {     
	const [event, changeEvent] = useState(eventData.data)

    const onChange = (value) => {
        const data = {...event}
        data['c' + config.linkedRelation[0]] = value
        changeEvent(data)
        updateEvent(eventData.entityId, data, scheduler)
    }

    const field = {
        name: config.id,
        title: config.singular,
        type: config.uiType,
        defaultValue: event['d' + config.id],
        foreignerEcn: config.foreignerEcn,
        linkedRelation: config.linkedRelation.length ? event['c' + config.linkedRelation[0]] : undefined
    }

    return (
        <Popover
            open={true}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
        >
            <PopoverContent minWidth='300'>
                <Title>
                    <Text>
                        {moment(eventData.from).format('dddd, MMMM D')}
                    </Text>
                    {permissions.Write &&
                        <IconButton onClick={handleEdit}>
                            <Create />
                        </IconButton>
                    }
                    {permissions.Delete &&
                        <IconButton onClick={handleDelete}>
                            <Delete />
                        </IconButton>
                    }
                </Title>
                <Field>
                    <Label>{field.title}</Label>
                    <Value>
                        <LinkedField
                            defaultValue={field.defaultValue}
                            handleUpdateValue={onChange}
                            foreignerEcn={field.foreignerEcn}
                            linkedRelation={field.linkedRelation}
                            name={field.name}
                            title={field.title}
                            readonly={!permissions.Write}
                        />
                    </Value>
                </Field>
                <Text>
                    {intl.formatMessage({id: "planning.from"})} {moment(eventData.from).format('HH:mm')} {intl.formatMessage({id: "planning.to"})} {moment(eventData.to).format('HH:mm')}
                </Text>
            </PopoverContent>
        </Popover>
    )
}

export default injectIntl(EventPopover)
